import { Box, Typography } from "@mui/material";

export const JobTotalFallbackCard = ({ amount }: { amount: number }) => (
  <Box sx={{ p: 2, borderRadius: 2, border: "1px solid", borderColor: "divider", bgcolor: "background.paper" }}>
    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700, textTransform: "uppercase" }}>
      Job total (from quote / override)
    </Typography>
    <Typography variant="h6" sx={{ fontWeight: 800, mt: 0.5 }}>
      {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(amount)}
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, fontSize: "0.8125rem" }}>
      All selected visits bill under this service. Adjust the line total in the table below if the amount should differ.
    </Typography>
  </Box>
);
